import { PackingSlipRouteService } from 'common/data';
import { BaseService } from 'core/services';

class PackingSlipService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new PackingSlipRouteService());
	}
	generatePdf(id, isManual) {
		var url = this.routeService.generatePdf(id, isManual);
		return this.apiClient.get(url);
	}
}

export default PackingSlipService;
